import * as XLSX from "xlsx"
import DateFormat from "../CustomerPortal/DateFormat"

const CreditTable = ({ header = [], data = [], selectedCustomer }) => {
    if (data?.error) return null

    const sumTotalAmount = (array) =>
        array.reduce((sum, item) => sum + parseFloat(item.Total || 0), 0)

    const total = sumTotalAmount(data)

    const formatDateForExcel = (date) => {
        if (!date) return ""
        const d = new Date(date)
        return d.toISOString().split("T")[0]
    }

    const handleExportExcel = () => {
        const sheetData = []

        // Meta info
        sheetData.push(["Customer", selectedCustomer || "All"])
        sheetData.push([])

        // Header
        sheetData.push(header)

        // Rows
        data.forEach((info) => {
            sheetData.push([
                info.bill_no,
                formatDateForExcel(info.Date),
                info.DiscountAmt,
                info.Total
            ])
        })

        // Total row
        sheetData.push([
            "Total",
            "",
            "",
            total.toFixed(3)
        ])

        const worksheet = XLSX.utils.aoa_to_sheet(sheetData)

        /* Column width = padding */
        worksheet["!cols"] = [
            { wch: 18 },
            { wch: 18 },
            { wch: 18 },
            { wch: 18 }
        ]

        /* Bold header + total */
        const headerRowIndex = 2
        const totalRowIndex = sheetData.length - 1

        header.forEach((_, colIndex) => {
            const cellRef = XLSX.utils.encode_cell({ r: headerRowIndex, c: colIndex })
            if (worksheet[cellRef]) {
                worksheet[cellRef].s = { font: { bold: true } }
            }
        })

        const totalCellRef = XLSX.utils.encode_cell({ r: totalRowIndex, c: 3 })
        if (worksheet[totalCellRef]) {
            worksheet[totalCellRef].s = { font: { bold: true } }
        }

        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, "Total Credit Sales")

        const customerName = selectedCustomer.replace(/\s+/g, "_")

        XLSX.writeFile(
            workbook,
            `total-credit-sales-${customerName}.xlsx`
        )
    }

    return (
        <>
            {/* Export Button */}
            <div className="flex justify-end mt-4">
                <button
                    onClick={handleExportExcel}
                    className="
                        px-4 py-2
                        rounded-md
                        bg-green-600
                        text-white
                        text-sm
                        font-medium
                        hover:bg-green-700
                        transition
                    "
                >
                    Export to Excel
                </button>
            </div>

            <div className="table-credit-responsive">
                <table className="table-credit">
                    <thead>
                        <tr className="position-sticky">
                            {header.map((headers, index) => (
                                <th className="no-wrap" key={index}>
                                    {headers}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {data.map((info, index) => (
                            <tr key={index}>
                                <td className="no-wrap">{info.bill_no}</td>
                                <td className="no-wrap">
                                    <DateFormat date={info.Date} />
                                </td>
                                <td className="no-wrap">{info.DiscountAmt}</td>
                                <td className="no-wrap">{info.Total}</td>
                            </tr>
                        ))}

                        <tr>
                            <td className="no-wrap">Total:</td>
                            <td></td>
                            <td></td>
                            <td className="no-wrap-bold">
                                {total.toFixed(3)}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default CreditTable
